import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const TEAM_AVATAR_SIZE = "34px";

export const useTeamSummaryStyles = makeStyles({
  teamSummary: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    flex: 1,
    minWidth: 0,
  },
  teamAvatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: TEAM_AVATAR_SIZE,
    height: TEAM_AVATAR_SIZE,
    borderRadius: designTokens.borderRadius.md,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.bold,
  },
  teamMeta: {
    flex: 1,
    minWidth: 0,
    maxWidth: "100%",
  },
  teamNameRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  teamName: {
    fontSize: designTokens.fontSize["2xs"],
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[900],
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  teamDetails: {
    display: "block",
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    marginTop: designTokens.spacing[1],
  },
});
